import { store } from "../store";

export const isSSOAuthenticated = () => {
    const apiKey = store.getState().ssoAuth.apiKey;
    const userAuthenticated = store.getState().ssoAuth.userAuthenticated;

    return userAuthenticated && apiKey === sessionStorage.apiKey;
};
